import React, {Component} from 'react';
import {Col, Button, Row, Card, CardBody, ButtonToolbar} from 'reactstrap';
import {
    provider_changed,
    providers_open_form,
    provider_deal_changed,
    provider_name_changed,
    provider_insert,
    provider_update
} from '../../../redux/actions/ProvidersActions';
import LoadingProgress from '../../../components/LoadingProgress';
import DropZoneField from '../../../components/DropZoneField';
import Alert from '../../../components/Alert';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as http from '../../../modules/http';
import * as environment from "../../../modules/environment";
import {fetchUtilsDataIfNeeded} from "../../../redux/actions/UtilsActions";
import * as TextManager from "../../../modules/languages/TextManager";
import Select from "../../../components/Select";



class EditProviderForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            warning: '',
            error: false,
            saved: false,
            files: this.props.provider.id === 0 ? [[]] : [[{preview: environment.getServerBasePath() + '/providers/download?providerID=' + this.props.provider.id}]],
            filesBase64: [[]],
            filesInfo: [{}]
        }
    }

    componentDidMount() {
    }

    selectDoc(files, index) {

        if (files.length === 0) {
            let tmp = this.state.files;
            tmp.splice(index, 1);

            let res = this.state.filesBase64;
            res.splice(index, 1);

            let info = this.state.filesInfo;
            info.splice(index, 1);
            this.setState({files: tmp, filesBase64: res, filesInfo: info});
        }
        else {
            // Saving name and size
            let tmpInfo = this.state.filesInfo;
            let fr = new FileReader();
            fr.onload = function () {
                let img = new Image();
                img.onload = function () {
                    tmpInfo[index] = {name: files[0].name, size: img.width + "x" + img.height};
                    tmpInfo.push({});
                };
                img.src = fr.result;
            };
            fr.readAsDataURL(files[0]);

            // Saving doc
            this.getFilesBase64Rec(files, [], 0,
                (result) => {
                    let tmp = this.state.files;
                    tmp[index] = files;
                    tmp.push([]);

                    let res = this.state.filesBase64;
                    res[index] = result;
                    res.push([]);
                    this.setState({files: tmp, filesBase64: res, filesInfo: tmpInfo});
                });
        }

    }

    getFilesBase64Rec(fileObjs, filesBase64, index, callback) {

        this.getBase64(fileObjs[index], (result) => {

            filesBase64.push(result);
            if (index < fileObjs.length - 1) {
                this.getFilesBase64Rec(fileObjs, filesBase64, index + 1, callback)
            }
            else {
                callback(filesBase64);
            }
        });
    }

    getBase64(file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.warn('Error: ', error);
        };
    }

    saveProvider(index) {
        if (!this.props.provider.name || this.props.provider.name === '') {
            this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectName});
            return;
        }
        if (!this.props.provider.deals || this.props.provider.deals.length === 0) {
            this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseAddAtLeastOneDeal});
            return;
        }
        else{
            let shouldReurn =false;
            this.props.provider.deals.forEach((deal) => {
                if(!deal.amount){
                    deal.amount = "";
                }
                if(this.props.provider.providerType !== 2 && (!deal.text || deal.text.length === 0)){

                    shouldReurn = true;
                }
                console.log(this.props.provider.providerType);
                if(this.props.provider.providerType === 1){
                    if(!deal.amount || deal.amount === ""){

                        shouldReurn = true;
                    }
                }
            });

            if(shouldReurn){
                this.setState({warning: TextManager.getCurrentTextResource().Text.dealFieldsCantBeEmpty});

                return;
            }
        }

        this.setState({warning: '', saving: true, error: false});




        const isAdding = (this.props.provider.id === 0);

        const data = {
            id: this.props.provider.id,
            name: this.props.provider.name,
            deals: this.props.provider.deals,
            providerType: this.props.provider.providerType,
            logo: {
                name: (this.state.filesInfo[0] && this.state.filesInfo[0].name) ? this.state.filesInfo[0].name : "",
                size: (this.state.filesInfo[0] && this.state.filesInfo[0].size) ? this.state.filesInfo[0].size : "",
                data: (this.state.filesBase64[0] && this.state.filesBase64[0][0]) ? this.state.filesBase64[0][0] : ""
            },
            link: this.props.provider.link === undefined ? '' : this.props.provider.link,
            link_text: this.props.provider.link_text === undefined ? '' : this.props.provider.link_text
        };

        //console.log(data);


        var requestUrl = 'providers/update';
        if (isAdding) {
            requestUrl = 'providers/new';
        }


        http.postToServer(
            requestUrl,
            data,
            (response) => {
                //console.debug('postToServer');
                this.setState({saving: false, error: false});

                if (isAdding) {
                    this.props.dispatch(provider_insert(response.data));
                }
                else {
                    this.props.dispatch(provider_update(response.data, index));
                }

                this.props.dispatch(fetchUtilsDataIfNeeded(true));
                this.props.onClose();

            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})

            }
        );

    }

    render() {

        const isAdding = (this.props.provider.id === 0);
        return (

            <Row>
                {this.state.warning !== '' &&
                <Col sm={12} md={12} xs={12} lg={12}>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span
                            className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                        </p>
                    </Alert>
                </Col>
                }

                <Col>
                    <Card>
                        <CardBody style={{boxShadow: 'none'}}>
                            <div className='card__title'>
                                <h5 className='bold-text'>תמונה</h5>
                            </div>
                            <div>
                                <DropZoneField customHeight
                                               multi={false}
                                               files={this.state.files[0]}
                                               onChange={(files) => this.selectDoc(files, 0)}
                                />
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={7}>
                    <Card>
                        <CardBody style={{boxShadow: 'none'}}>
                            <div className='card__title'>
                                <h5 className='bold-text'>{!isAdding ? "ערוך ספק" : "הוסף ספק"}</h5>
                            </div>
                            <form className='form form--horizontal'>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>שם</label>
                                    <div className='form__form-group-field'>
                                        <input
                                            dir={"auto"}
                                            value={this.props.provider.name}
                                            onChange={(event) => this.props.dispatch(provider_name_changed("name", event.target.value))}
                                        />
                                    </div>
                                </div>


                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>סוג</label>
                                    <div className='form__form-group-field'>
                                        <Select
                                            name='select'
                                            value={this.props.provider.providerType}
                                            type={"select"}
                                            select
                                            options={this.props.utilsData.data.providersTypes}
                                            onChange={(e) => this.props.dispatch(provider_name_changed("providerType", e.value))}>
                                        </Select>
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>כמה מילים שיפנו לקישור</label>
                                    <div className='form__form-group-field'>
                                        <input
                                            dir={"auto"}
                                            value={this.props.provider.link_text}
                                            onChange={(event) => this.props.dispatch(provider_name_changed("link_text", event.target.value))}
                                        />
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>קישור</label>
                                    <div className='form__form-group-field'>
                                        <input
                                            dir={"auto"}
                                            value={this.props.provider.link}
                                            onChange={(event) => this.props.dispatch(provider_name_changed("link", event.target.value))}
                                        />
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>עסקאות
                                    </label>
                                </div>

                                {this.props.provider.deals.map((deal, index) =>

                                    <div className='form__form-group' key={index}>
                                        <label
                                            className='form__form-group-label'>{index + 1}</label>
                                        <div className='form__form-group-field'>
                                            <input
                                                dir={"auto"}
                                                value={deal.text}
                                                onChange={(event) => this.props.dispatch(provider_deal_changed("text", event.target.value, index))}
                                            />
                                            <input
                                                dir={"auto"}
                                                value={deal.amount}
                                                onChange={(event) => this.props.dispatch(provider_deal_changed("amount", event.target.value, index))}
                                            />
                                            <div style={{ padding: '10px'}}>
                                                <i className="fas fa-trash" style={{cursor: 'pointer'}}
                                                   onClick={(event) => this.props.dispatch(provider_changed("delete", "deals", null, index))}
                                                > </i>
                                            </div>
                                        </div>


                                    </div>
                                )}

                                {this.props.provider.deals.length === 0 &&
                                <div className='form__form-group'>
                                    No deals
                                </div>
                                }

                                <div className='form__form-group' style={{justifyContent: 'flex-end'}}>
                                    <Button color='primary' size='sm'
                                            style={{padding: "0px 15px", margin: "0px"}}
                                            onClick={(event) => this.props.dispatch(provider_changed("add", "deals", ""))}>
                                        <i className="fas fa-plus" > </i>
                                    </Button>
                                </div>


                                {this.props.updateStatus !== 'request' &&
                                <div className='form__form-group'>
                                    <ButtonToolbar className="form__button-toolbar">
                                        <Button color="primary" onClick={() => this.saveProvider(this.props.index)}>שמור</Button>
                                        <Button type="button" onClick={() => this.props.dispatch(providers_open_form(this.props.provider))}>ביטול</Button>
                                    </ButtonToolbar>
                                </div>}


                            </form>
                            {this.props.updateStatus === 'request' &&
                            <Row>
                                <LoadingProgress/>
                            </Row>}
                            {this.props.updateStatus === 'error' &&
                            <Row>
                                <Alert color='danger' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>test</span>
                                    </p>
                                    <p>test</p>
                                </Alert>
                            </Row>}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        provider: state.providers.provider,
        status: state.providers.status,
        updateStatus: state.providers.updateStatus,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(EditProviderForm))